import React from 'react';

export default () => (
  <svg width="56" height="40" viewBox="-1 -1 58 42" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(0 -3)">
          <text fontFamily="Avenir Next" fontSize="11" fill="#A3A9B2">
            <tspan x="10" y="11.56">
              Breakfast
            </tspan>
            <tspan x="10" y="26.56">
              Lunch
            </tspan>
            <tspan x="10" y="41.56">
              Dinner
            </tspan>
          </text>
          <ellipse stroke="#B7C2CC" cx="3.5" cy="9.06" rx="3.5" ry="3.5" />
          <ellipse fill="#B7C2CC" cx="3.5" cy="9.06" rx="1.5" ry="1.5" />
          <ellipse stroke="#B7C2CC" cx="3.5" cy="23.06" rx="3.5" ry="3.5" />
          <ellipse stroke="#B7C2CC" cx="3.5" cy="38.06" rx="3.5" ry="3.5" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/radio-widget.es6.js